import request from '@/utils/request'

// 【sku2需求中废弃此接口】
/* 商品模版列表 */
export function commodityList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/commerce/template/list',
    method: 'POST',
    data,
  })
}

// 【sku2需求中废弃此接口】
/* 商品模版上/下架 */
export function commodityUpdateState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/commerce/template/updateState',
    method: 'POST',
    data,
  })
}

// 【sku2需求中废弃此接口】
/* 新增/编辑商品模版 */
export function commoditySave(data = {}) {
  return request({
    url: '/admin/v1/vehicle/commerce/template/save',
    method: 'POST',
    data,
    bizCode: [35314],
  })
}

// 【sku2需求中废弃此接口】
/**
 * 获取商品公司合作平台列表
 * @param {Object} data 参数
 * @param {number} data.enterpriseId 主体ID
 * @param {number} [data.modelId] 车型ID，批量上架商品场景中，可不传，此时返回物流车和网约车的所有平台
 * @returns {ListResponse<{code:number, name:string, source:number}>} 合作平台列表
 */
export function getCooperationPlatformList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/goods/cooperationPlatformList',
    method: 'POST',
    data,
  })
}

// 【sku2需求中废弃此接口】
/* 商品模版详情 */
export function commodityDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/commerce/template/detail',
    method: 'POST',
    data,
  })
}

/* 门店列表 */
export function storeList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/commerce/store/list',
    method: 'POST',
    data,
  })
}

/* 门店列表（全部，根据城市筛选） */
export function storeListAll(data = {}) {
  return request({
    url: '/admin/v1/vehicle/commerce/store/listAll',
    method: 'POST',
    data,
  })
}

/* 门店详情 */
export function storeDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/commerce/store/detail',
    method: 'POST',
    data,
  })
}

/* 新增或编辑门店 */
export function storeSave(data = {}) {
  return request({
    url: '/admin/v1/vehicle/commerce/store/save',
    method: 'POST',
    data,
  })
}

// 获取车型下拉选项
export function goodModelListAll(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/model/goodModelListAll',
    method: 'POST',
    data,
  })
}
// 根据车型ID获取车型信息（含接单资质）
export function getCarLevelByModelId(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/model/getCarLevelByModelId',
    method: 'POST',
    data,
  })
}
// 【sku2需求中废弃此接口】
// 查询商品基础&服务信息
export function getGoodsBaseInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/goods/query',
    method: 'POST',
    data,
  })
}

// 查询所有租赁方案
export function getPlanListByGoods(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/listByGoods',
    method: 'POST',
    data,
  })
}

// 【sku2需求中废弃此接口】
// 保存商品基础信息
export function saveRentGoods(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/goods/save',
    method: 'POST',
    data,
  })
}

// 【sku2需求中废弃此接口】
// 更新商品服务信息
export function updateRentGoodsService(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/goods/v3/serviceUpdate',
    method: 'POST',
    data,
    signParams: [
      'body.adminTenantId',
      'body.draftId',
      'body.enterpriseId',
      'body.state',
    ],
  })
}

// 签约企业主体
export function getEnterpriseNameList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/merchant/getEnterpriseNameList',
    method: 'POST',
    data,
  })
}

/**
 * @typedef {Object} EnterpriseInfo 主体详情
 * @property {number} id 主体ID
 * @property {string} tenantId 租户id（现在没赋值，服务返回null，考虑弃用）
 * @property {string} corporationName 企业全称
 * @property {string} licenceNo 统一社会信用代码
 * @property {string} legalName 法人名称
 * @property {string} legalIdNo 法人身份证号
 * @property {string} legalMobile 法人手机号
 * @property {string} contactName 联系人姓名
 * @property {string} contactMobile 联系人电话
 * @property {string} businessLicensePic 营业执照url
 * @property {string} businessStatus 经营状态：10存续（开业/在营/在册）、20在业、30吊销、40注销、50迁入、60迁出、70停业、80清算
 * @property {string} businessStatusDesc 经营状态：10存续（开业/在营/在册）、20在业、30吊销、40注销、50迁入、60迁出、70停业、80清算 描述
 * @property {string} establishDate 成立日期
 * @property {string} registrationAuthority 登记机关
 * @property {string} businessScope 经营范围
 * @property {string} registrationMobile 注册电话
 * @property {string} registrationAddress 注册地址
 * @property {string} yeepayState 易宝开通状态  1已开通，0未开通
 * @property {string} esignState E签宝开通状态  1已开通，0未开通
 * @property {string[]} cooperationPlatformList 合作平台 名称列表，中文名称
 * @property {0 | 1} defaultType 0 - 代表默认主体, 1 - 非默认，默认主体不能编辑
 * @property {Object} signOrgWarn e签宝预警信息
 * @property {number} signOrgWarn.warnType 预警类型 -1未授权0正常1授权中2授权过期3即将过期4已授权但未启用
 * @property {string} signOrgWarn.expireTime 过期时间(yyyy-MM-dd)（已过期的会有过期时间）
 * @property {number} signOrgWarn.expireDays 即将过期天数（即将过期的会有即将过期天数）
 * @property {string} signOrgWarn.orgIdCardNum 统一社会信用代码证号（此场景下一定有值）
 * @property {string} signOrgWarn.orgName 企业主体全称（此场景下一定有值）
 * @property {string} signOrgWarn.orgId e签宝账号id
 * @property {Object[]} cooperationList 合作平台 列表, 可逐步替换 cooperationPlatformList 字段
 * @property {number} cooperationList.id 合作平台 编码
 * @property {string} cooperationList.name 合作平台 名称
 */

/**
 * 根据企业主体ID获取主体详情
 * @param {Object} data 参数
 * @param {number} data.id 主体ID
 * @returns {APIResponse<EnterpriseInfo>} 主体详情
 */
export function getGoodsEnterpriseInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/merchant/getGoodsEnterpriseInfo',
    method: 'POST',
    data,
  })
}

/**
 * 获取门店二维码的base64
 * @param {Object} data
 * @param {number} data.id 门店id
 * @returns {APIResponse<{data: string}>}
 */
export function getStoreQRCode(data = {}) {
  return request({
    url: '/admin/v1/vehicle/commerce/store/getStoreQRCode',
    method: 'POST',
    data,
  })
}
